import { useMemo } from "react";
import * as THREE from "three";
import { DrawPolygonTool } from "@treegram/tools-draw-polygon";
import { SaveTool } from "@treegram/tools-save";
import { DrawLineTool } from "@treegram/tools-draw-line";
import { HighlighterTool } from "@treegram/tools-highlighter";
import { CameraTool } from "@treegram/tools-camera";
import { createViewerTool, ViewerTool } from "@/hooks/viewer/use-viewer.ts";

export const useStoreyMeasuresTools = (): ViewerTool[] =>
    useMemo<ViewerTool[]>(() => [
        createViewerTool({
            key: "drawLineTool",
            factory: (ctx) => new DrawLineTool(ctx.viewer),
            setup: (tool) => {
                tool.setupOptions({ drawMultiple: true });
            },
        }),
        createViewerTool({
            key: "measureTool",
            factory: (ctx) => {
                const tool = new DrawLineTool(ctx.viewer);
                tool.name = "measureTool";
                return tool;
            },
            setup: (tool) => {
                tool.setupOptions({ drawMultiple: true });
            },
        }),
        createViewerTool({
            key: "drawPolygonTool",
            factory: (ctx) => new DrawPolygonTool(ctx.viewer),
            setup: (tool) => {
                tool.setupOptions({ drawMultiple: true });
            },
        }),
        createViewerTool({
            key: "drawLineToolEditing",
            factory: (ctx) => {
                const tool = new DrawLineTool(ctx.viewer);
                tool.name = "drawLineToolEditing";
                return tool;
            },
            setup: (tool) => {
                tool.setupOptions({ drawMultiple: false });
            },
        }),
        createViewerTool({
            key: "drawPolygonToolEditing",
            factory: (ctx) => {
                const tool = new DrawPolygonTool(ctx.viewer);
                tool.name = "drawPolygonToolEditing";
                return tool;
            },
            setup: (tool) => {
                tool.setupOptions({ drawMultiple: false });
            },
        }),
        createViewerTool({
            key: "saveTool",
            factory: (ctx) => new SaveTool(ctx.viewer),
        }),
        createViewerTool({
            key: "cameraTool",
            factory: (ctx) => new CameraTool(ctx.viewer),
        }),
        createViewerTool({
            key: "highlighterTool",
            factory: (ctx) => new HighlighterTool(ctx.viewer),
            setup: async (tool) => {
                tool.updateOptions({
                    color: new THREE.Color("#FF0000"),
                    opacity: 1,
                    transparent: false,
                    renderedFaces: 1,
                });
                await tool.activate();
            },
        }),
    ], []);

export default useStoreyMeasuresTools;
